
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/may-2019-update",
      function () {
        return require("private-next-pages/blog/may-2019-update.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/may-2019-update"])
      });
    }
  